const calculateReward = (dailyReturn) => (numberOfTokens, dayData) =>
  (numberOfTokens * (Number(dayData) * dailyReturn)) / 100;

export default calculateReward;
